// Виды документов, которые клиент грузит сам. Ключи совпадают с полями
// анкеты (createCreditAppeal) и с видами на бэке (ClientUploadRules).
export const CLIENT_UPLOAD_KINDS = {
  incomeCertificate: {
    title: 'Справка / выписка о доходах',
    managerTitle: 'Справка / выписка о доходах',
    hint: 'PDF или фото документа',
    photo: false,
  },
  workCertificate: {
    title: 'Выписка со счёта',
    managerTitle: 'Выписка со счёта',
    hint: 'PDF или фото документа',
    photo: false,
  },
  clientPhoto: {
    title: 'Ваше фото',
    managerTitle: 'Фото клиента',
    hint: 'Лицо хорошо видно, без очков и головного убора',
    photo: true,
  },
};

// Порядок совпадает с бэком (ClientUploadRules.Kinds).
export const ALL_KINDS = ['incomeCertificate', 'workCertificate', 'clientPhoto'];

// Что отметить по умолчанию: по условиям анкеты, без уже полученного. Менеджер
// может изменить выбор — например, запросить только выписку.
export const defaultKinds = ({ showIncome, showWork, received }) =>
  [
    ...(showIncome ? ['incomeCertificate'] : []),
    ...(showWork ? ['workCertificate'] : []),
    'clientPhoto',
  ].filter((kind) => !received?.[kind]);

// Список файлов статуса → { вид: файл }.
export const receivedByKind = (files) =>
  (files || []).reduce((acc, f) => ({ ...acc, [f.kind]: f }), {});

// Поле анкеты заполнено, если файл приложил менеджер или прислал клиент.
export const hasDocument = (files, received, kind) => !!(files?.[kind] || received?.[kind]);

// Размер после уменьшения: длинная сторона не больше max, пропорции те же.
// Фото с современного телефона бывает 10+ МБ — на мобильном интернете это
// долго, а для банков хватает разрешения скана.
export const fitSize = (width, height, max) => {
  const longest = Math.max(width, height);
  if (longest <= max) return { width, height };
  const k = max / longest;
  return { width: Math.round(width * k), height: Math.round(height * k) };
};

export const MAX_IMAGE_SIDE = 2400;

// Уменьшает картинку в браузере; PDF и любые неудачи отдают как есть.
export const shrinkImage = (file) => {
  if (!file || !/^image\/(jpeg|png|webp|heic|heif)$/i.test(file.type || '')) return Promise.resolve(file);
  return new Promise((resolve) => {
    const url = URL.createObjectURL(file);
    const img = new Image();
    img.onload = () => {
      try {
        const { width, height } = fitSize(img.naturalWidth, img.naturalHeight, MAX_IMAGE_SIDE);
        const canvas = document.createElement('canvas');
        canvas.width = width;
        canvas.height = height;
        canvas.getContext('2d').drawImage(img, 0, 0, width, height);
        canvas.toBlob(
          (blob) => {
            URL.revokeObjectURL(url);
            // Выросло или не получилось — оставляем исходный файл.
            resolve(blob && blob.size < file.size ? new File([blob], 'photo.jpg', { type: 'image/jpeg' }) : file);
          },
          'image/jpeg',
          0.85
        );
      } catch (e) {
        URL.revokeObjectURL(url);
        resolve(file);
      }
    };
    img.onerror = () => {
      URL.revokeObjectURL(url);
      resolve(file);
    };
    img.src = url;
  });
};
